module.exports = __webpack_public_path__ + "static/media/moon-cloud.e0216a5d.png";